import axios from '@axios'

export default {
  namespaced: true,
  state: {
    showOverlay: false, // carga al actualizar formulario
    formulario: [{ secciones: [] }],
    preguntaFocus: { a: '' }, // no se logro darle focus a un nueva pregunta creada -- por revisar
  },
  getters: {},
  mutations: {},
  actions: {

    getFormulario(ctx, idFormulario) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/recursos/formulario/${idFormulario}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updateFormulario(ctx, formulario) {
      return new Promise((resolve, reject) => {
        axios
          .post('/recursos/formulario', formulario)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getRespuestasPregunta(ctx, { idFormulario, idPregunta }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/recursos/formulario/${idFormulario}/respuesta?pregunta_id=${idPregunta}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getDataFormulario(ctx, idFormulario) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/recursos/formulario/${idFormulario}/data`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
